/**
 * Private Circle: лендинг, waitlist-баннер, форма заявки, community workspace.
 * Для релиза временно false. Backend не зависит от этого флага.
 * Чтобы вернуть: поставить true и пересобрать фронт.
 */
export const COMMUNITY_ENABLED = true;

/**
 * AI-ассистент: оверлей предпросмотра prompt перед отправкой в OpenAI.
 * Сейчас скрыт (false) — сообщение уходит сразу.
 * Чтобы вернуть: поставить true и пересобрать фронт.
 */
export const AI_ASSISTANT_DEV_PREVIEW_ENABLED = false;
